import {BasePanelPage} from "../../BasePanelPage";
import {Messages} from "../../../../../Messages";
import {registerStyle} from "../../../../../../stem-core/src/ui/style/Theme";
import {SubscribeReviewOrderPanelStyle} from "../SubscribeReviewOrderPanel";
import {addressController} from "../../../../inline-subscription/AddressController";
import {subscribePlanController} from "../../../../inline-subscription/SubscribePlanController";
import {subscribeFlowState} from "../../../../inline-subscription/SubscribeFlowState";
import {Link} from "../../../../../../stem-core/src/ui/UIPrimitives";
import {Router} from "../../../../../../stem-core/src/ui/Router";
import {INLINE_GIFT_SUBSCRIPTION_URLS} from "../../../../PanelConstants";
import {MessageElement} from "../../../../../widget/ui/MessageElement";
import {MerchantButton} from "../../../../../common/MerchantButton";
import {NOOP_FUNCTION} from "../../../../../../stem-core/src/base/Utils";


@registerStyle(SubscribeReviewOrderPanelStyle)
export class GiftSubscriptionReviewOrderPanel extends BasePanelPage {
    getDefaultOptions() {
        return {
            ...super.getDefaultOptions(),
            title: Messages.reviewOrder,
        };
    }

    handlePrimaryButtonClick() {
        Router.changeURL(INLINE_GIFT_SUBSCRIPTION_URLS.paymentDetails);
    }

    render() {
        const {styleSheet} = this;
        const shippingAddress = addressController.selectedAddress;
        const {selectedOffer} = subscribePlanController;
        const discountInfo = subscribePlanController.getDiscountInfo(selectedOffer);
        const finalPrice = discountInfo ? selectedOffer.formatPrice(discountInfo.finalPrice) : "-";
        const cycle = selectedOffer.getCycleDuration(true);

        return [
            <div className={styleSheet.reviewItem} testId="subscriptionPlanSection">
                <div className={styleSheet.reviewItemTitleContainer}>
                    <div className={styleSheet.reviewItemTitle}>{Messages.subscriptionPlan}</div>
                    <Link value={Messages.change} className={styleSheet.link} testId="changeButton"
                          onClick={() => {
                              subscribePlanController.update({onSelectCancel: () => Router.back()});
                              Router.changeURL(INLINE_GIFT_SUBSCRIPTION_URLS.subscriptionPlans);
                          }}/>
                </div>
                <MessageElement className={styleSheet.reviewItemDescription}
                                args={[selectedOffer.coverage.name, finalPrice, cycle]}
                                message={Messages.subscriptionPlanDescription} />
            </div>,
            selectedOffer.shouldCollectAddress() ? [
                <div className={styleSheet.lineSeparator}/>,
                <div className={styleSheet.reviewItem} testId="addressSection">
                    <div className={styleSheet.reviewItemTitleContainer}>
                        <div className={styleSheet.reviewItemTitle}>{Messages.recipientAddress}</div>
                        <Link value={Messages.edit} className={styleSheet.link} testId="editButton"
                              onClick={() => Router.changeURL(INLINE_GIFT_SUBSCRIPTION_URLS.address)}/>
                    </div>
                    <div className={styleSheet.reviewItemDescription}>
                        <div className={styleSheet.nameOnAddress}>{shippingAddress.getRecipientName()}</div>
                        <div className={styleSheet.addressDetails}>{shippingAddress}</div>
                    </div>
                </div>
            ] : null,
            <div className={styleSheet.lineSeparator}/>,
            <div className={styleSheet.reviewItem} testId="paymentMethodSection">
                <div className={styleSheet.reviewItemTitle}>{Messages.payment}</div>
                <MessageElement className={styleSheet.reviewItemDescription} args={[finalPrice]}
                                message={Messages.giftSubscriptionPaymentDescription} />
            </div>,
            <MerchantButton onClick={() => this.handlePrimaryButtonClick()} className={styleSheet.button}>
                {Messages.continueToPayment}
            </MerchantButton>,
            <div className={styleSheet.center}>
                <div onClick={() => {
                    subscribePlanController.update({onSelectCancel: NOOP_FUNCTION});
                    Router.back();
                }} className={styleSheet.secondaryButton}>
                    {Messages.back}
                </div>
            </div>
        ];
    }
}
